



















import Vue from "vue";

export default Vue.extend({
  name: "UnreadFeesCard",
  props: {
    unpaidFeeCount: { type: Number }
  },
  methods: {
    redirectToLateFees() {
      this.$router.push("/payments?myPlayers=true");
    }
  }
});
